function normalizePhoneNumber(phoneNumber) {
  let normalizedPhone = phoneNumber
    .replace("(", "")
    .replace(")", "")
    .replace("-", "")
    .replace(" ", "");
  return normalizedPhone;
}

function determineAvailabilityStartDate(
  context,
  startDate,
  typeId1,
  typeId2,
  dateOfBirth
) {
  let newStartDate = startDate || new Date();
  const serviceType1 = context.getters.serviceType(typeId1);
  const serviceType2 = context.getters.serviceType(typeId2);
  if (dateOfBirth && (serviceType1.MinimumAge || serviceType2.MinimumAge)) {
    let minimumAge = serviceType1.MinimumAge || serviceType2.MinimumAge;
    let minBirthDate = new Date();
    minBirthDate.setFullYear(minBirthDate.getFullYear() - minimumAge);
    console.log(minBirthDate);
    let dob = new Date(dateOfBirth);
    if(dob > minBirthDate) {
      let newCalculatedDate = new Date();
      newCalculatedDate.setDate(dob.getDate());
      newCalculatedDate.setMonth(dob.getMonth());
      if (newCalculatedDate > newStartDate) {
        newStartDate = newCalculatedDate;
      }
    }  
  }
  return newStartDate;
}

function updateLocationAvailability(currentLocation, currentLocationAvailabilityDates, locationAvailability) {
  let updatedLocationAvailability = currentLocationAvailabilityDates || [];
  console.log(currentLocation, currentLocationAvailabilityDates, locationAvailability);

  //Check if Date Already Exists
  locationAvailability.LocationAvailabilityDates.forEach((date, index) => {
    console.log(index);
    if(currentLocationAvailabilityDates.find(d=>d.AvailabilityDate === date.AvailabilityDate)){
      console.log('date found');
      //Update existing date
      updateLocationAvailability[index] = date;
    }  else {
      //Add new date
      updatedLocationAvailability.push(date);
      console.log(date);
    }
  });
  
  return updatedLocationAvailability;

}

function updateSelectAriaLabel (control, text){
  if(control){
    if(control.$el.children && control.$el.children.length > 1){
      console.log(text);
      control.$el.children[0].ariaLabel = text;
      console.log(control.$el.children[0].ariaLabel);
    }
  }

}

export default {
  normalizePhoneNumber: normalizePhoneNumber,
  determineAvailabilityStartDate: determineAvailabilityStartDate,
  updateLocationAvailability: updateLocationAvailability,
  updateSelectAriaLabel: updateSelectAriaLabel
};
